export const cardContainerStyles = {
  padding: "10px",
};
